<div id="controls" [class.controls--disabled]="disabled() === true">
  <!-- Single row: Cover + Title | Scrubber | Rewind/Play/Forward/Speed/Volume -->
  <div class="controls__bar">
    <!-- Left: Cover + Title -->
    @if (currentItem?.episode?.title) {
      <div class="controls__meta">
        <hypecast-image
          [src]="episodeImageUrl"
          [defaultImage]="'assets/150x150.png'"
          customClass="controls__cover-img"
          height="48px"
          width="48px"
          minHeight="48px">
        </hypecast-image>
        <div class="controls__title">{{ currentItem.episode.title }}</div>
      </div>
    }

    <!-- Middle: Scrubber with timer + duration -->
    <div class="controls__progress flex flex-row items-center">
      <div #timer class="controls__timer flex-initial">
        0:00
      </div>
      <div class="controls__slider flex-auto">
        <mat-slider [attr.disabled]="disabled()" #slider [min]="min"
          [max]="max" [step]="stepSize">
          <input (dragEnd)="setTimerWhenDragging($event)" [formControl]="sliderControl" matSliderThumb>
        </mat-slider>
      </div>
      <div class="controls__duration flex-initial">
        {{ duration | minuteSeconds }}
      </div>
    </div>

    <!-- Right: Rewind | Play/Pause | Forward | Speed | Volume -->
    <div class="controls__buttons flex flex-row items-center">
      <button class="controls__btn" (click)="rewind()" aria-label="Rewind 30 seconds">
        <mat-icon>replay_30</mat-icon>
      </button>

      <button class="controls__btn controls__btn--play" (click)="isPlaying === true ? pause() : play()" aria-label="Play/Pause">
        @if (isLoading() === true) {
          <mat-spinner color="primary" [diameter]="30"></mat-spinner>
        }
        @if (isLoading() === false) {
          <mat-icon class="play-icon">
            {{ isPlaying === true ? 'pause_circle_filled' : 'play_circle_filled' }}
          </mat-icon>
        }
      </button>

      <button class="controls__btn" (click)="forward()" aria-label="Forward 30 seconds">
        <mat-icon>forward_30</mat-icon>
      </button>

      <button class="controls__btn controls__btn--speed" (click)="toggleSpeed()">
        {{ playbackRate }}x
      </button>

      <hypecast-content-language-switcher

        class="controls__language"

        [locales]="currentItem?.episode?.availableLocales"

        [selected]="currentItem?.episode?.resolvedLocale"

        [source]="currentItem?.episode?.sourceLocale ?? currentItem?.episode?.language"

        (localeChange)="onLocaleSelected($event)">

      </hypecast-content-language-switcher>


      @if (hasTranscript()) {
        <button class="controls__btn controls__btn--transcript" (click)="transcriptToggle.emit()"
          [class.controls__btn--transcript-active]="transcriptOpen()" aria-label="Toggle transcript">
          <mat-icon>description</mat-icon>
          <span>{{ "Hypecast Plugin.Transcript" | translate }}</span>
        </button>
      }

      @if (!isMobile) {
        <div class="controls__volume">
          <button class="controls__btn" (click)="toggleMute()" aria-label="Volume">
            <mat-icon>{{ isMuted ? 'volume_off' : 'volume_up' }}</mat-icon>
          </button>
          <div class="controls__volume-slider">
            <mat-slider [min]="0" [max]="100" [step]="1">
              <input [formControl]="volumeControl" matSliderThumb>
            </mat-slider>
          </div>
        </div>
      }
    </div>
  </div>
</div>
